import { LocalStorageKey } from "@/constants/constants";
import { getLocalStorageItem } from "@/lib/localStorage";
import {
  getAutoLoginState,
  updateAutoLoginState,
} from "@/stores/autoLoginStore";
import { upDateUserStore, userStore } from "@/stores/userStore";

export function useAutoLogin() {
  const autoLogin = () => {
    // 检查 URL token 部分功能带cToken跳转
    const token = getLocalStorageItem(LocalStorageKey.TOKEN, "");

    const isChangeToken = token !== userStore.token;
    // 使用 queueMicrotask 确保在 store 初始化后获取 localToken
    queueMicrotask(() => {
      if (token) {
        updateAutoLoginState({
          isTokenLogin: true,
          isAutoLogin: true,
          bChangeToken: isChangeToken,
        });
        userStore.token = token;
        upDateUserStore({ token });
      }
    });
  };

  return {
    isAutoLogin: () => getAutoLoginState().isAutoLogin,
    isTokenLogin: () => getAutoLoginState().isTokenLogin,
    bChangeToken: () => getAutoLoginState().bChangeToken,
    autoLogin,
  };
}
